// Module
var code = "<div class=\"row\" ng-class=\"{'form-horizontal': layout === 'horizontal',\r\n     'alternating-row-white': showAlternateRowColors && !alternateRow,\r\n     'alternating-row-grey': showAlternateRowColors && alternateRow}\" ng-transclude> </div> ";
// Exports
module.exports = code;